import { render, staticRenderFns } from "./news-detail-recommend.html?vue&type=template&id=50739fe5&scoped=true&external"
import script from "./news-detail-recommend.js?vue&type=script&lang=js&external"
export * from "./news-detail-recommend.js?vue&type=script&lang=js&external"
import style0 from "./news-detail-recommend.scss?vue&type=style&index=0&id=50739fe5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50739fe5",
  null
  
)

export default component.exports